<template>
    <yandex-map
        :coords="settings.coords"
        :zoom="settings.zoom"
        :controls="settings.controls"
        style="width: 1920px; height: 1020px"
        @map-was-initialized="initialized"
    >
        <carMarker
            v-if="cars.length"
            v-for="car in cars"
            :key="car.id"
            :coords="car.coordinates"
            :markerId="car.id"
            :info="car"
        />
        <clientMarker
            v-if="calls.length"
            v-for="call in calls"
            :key="call.id"
            :coords="call.coords"
            :markerId="call.id"
            :info="call"
        />
    </yandex-map>
</template>

<script>
import { yandexMap } from 'vue-yandex-maps';

import carMarker from './carMarker';
import clientMarker from './clientMarker';

import { MAP_SETTINGS } from '../const/common';

export default {
    props: {
        cars: {
            type: Array,
            default: [],
        },
        calls: {
            type: Array,
            default: [],
        },
    },
    name: 'mapComponent',
    components: { yandexMap, carMarker, clientMarker },
    data: () => {
        return {
            settings: MAP_SETTINGS,
        };
    },
    methods: {
        initialized(payload) {
            this.$emit('map-was-initialized', payload);
        },
    },
};
</script>

<style scoped></style>
